/**
 * アコーディオン
 *
 * コンテナ
 * [data-expandable]#固有ID
 *
 * コンテナ展開時
 * [data-expandable][data-expandable-expanded]
 *
 * コンテンツ
 * [data-expandable-content]
 *
 * トグル
 * [data-toggle="固有ID"]
 *
 * 展開
 * [data-expand="固有ID"]
 *
 * 収納
 * [data-collapse="固有ID"]
 *
 */


import ScrollTo from '../components/scrollto';

function toggle(container, scroll) {
    if (container.hasAttribute('data-expandable-expanded')) {
        collapse(container, scroll);
        return false;
    } else {
        expand(container, scroll);
        return true;
    }
}

function collapse(container, scroll) {
    const content = container.querySelector('[data-expandable-content]');

    content.querySelectorAll('[data-expandable-observe]').forEach(el => {
        resizeObserver.unobserve(el);
    });

    if (!scroll) {
        content.style.transition = 'none';
    }

    container.removeAttribute('data-expandable-expanded');
    content.style.maxHeight = null;

    if (scroll) {
        ScrollTo.scrollTo(`#${container.id}`, 0);
    }

    if (!scroll) {
        setTimeout(() => {
            content.style.transition = '';
        }, 10);
    }
}

const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
        const content = entry.target.closest('[data-expandable-content]');
        content.style.maxHeight = content.scrollHeight + 'px';

    }
});

function expand(container, scroll) {
    const content = container.querySelector('[data-expandable-content]');
    container.setAttribute('data-expandable-expanded', "");
    content.style.maxHeight = content.scrollHeight + 'px';

    content.querySelectorAll('[data-expandable-observe]').forEach(el => {
        resizeObserver.observe(el);
    });

    if (scroll) {
        setTimeout(() => {
            ScrollTo.scrollTo(`#${container.id}`);
        }, 100);
    }
}

export default {
    init: function () {
        document.querySelectorAll('[data-expandable]').forEach(container => {
            const id = container.id;

            document.querySelectorAll(`[data-expand="${id}"]`).forEach(link => {
                link.addEventListener('click', function (e) {
                    e.preventDefault();

                    if (link.hasAttribute('data-expand-single')) {
                        document.querySelectorAll('[data-expandable-expanded]').forEach(c => {
                            collapse(c, false);
                        });
                    }

                    expand(container, true);
                });
            });

            document.querySelectorAll(`[data-collapse="${id}"]`).forEach(link => {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    collapse(container, true);
                });
            });

            document.querySelectorAll(`[data-toggle="${id}"]`).forEach(link => {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    toggle(container, true);
                });
            });
        });
    }
};
